export default "__VITE_ASSET__zk2VyXVU__"